import ApiService from '../apiservice'

export default class ExecucaoCheckListService extends ApiService {
  constructor() {
    super('/execucaoCheckList')
  }

  cadastrar(exec) {
    return this.post('/',exec);
  }

  consultarCheckList(atividade) {
    return this.get(`/${atividade}`);
  }

  selecionarCheckList(exec) {
    return this.put('/', exec);
  }

  consultar(codigo) {
    return this.get(`/por-codigo/${codigo}`);
  }
}